import React from 'react';
import { DatabaseIcon, BotIcon, TargetIcon, PenLineIcon, ZapIcon, BarChart3Icon } from 'lucide-react';
const features = [{
  name: 'Natural Language Queries',
  description: 'Stop wrestling with complex filters. Just describe what you want in plain English, like "Find me dentists in Ohio with poor reviews."',
  icon: BotIcon
}, {
  name: '200M+ Local Businesses',
  description: "Natively connected to Openmart's massive database of local businesses, complete with verified owner contact info.",
  icon: DatabaseIcon
}, {
  name: 'Intelligent Scoring',
  description: 'The agent automatically evaluates and ranks leads based on your specific criteria, ensuring you focus on the highest-fit accounts first.',
  icon: TargetIcon
}, {
  name: 'Automated Outreach Drafts',
  description: "The agent doesn't just find leads; it writes personalized emails for each one, referencing specific data points like their recent reviews.",
  icon: PenLineIcon
}, {
  name: 'CRM Integration',
  description: 'Push your approved lead lists and drafted sequences directly into HubSpot, Salesforce, or your preferred sales engagement platform.',
  icon: ZapIcon
}, {
  name: 'Actionable Deliverables',
  description: 'Get structured outputs including ranked CSVs, market analysis summaries, and ready-to-send email drafts in a clean folder.',
  icon: BarChart3Icon
}];
export function OpenclawFeatures() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5435">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-12 lg:p-16 relative overflow-hidden" data-id="element-5436">
        <div className="max-w-2xl lg:text-center mx-auto mb-16" data-id="element-5437">
          <div className="text-sm font-bold leading-7 text-blue-600 uppercase tracking-wider mb-2" data-id="element-5438">
            Capabilities
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-5439">
            Everything your AI sales agent can do
          </h2>
          <p className="text-lg leading-relaxed text-slate-500" data-id="element-5440">
            Openmart's AI agent combines advanced language models with the
            world's most comprehensive local business database to automate your
            entire top-of-funnel workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-5441">
          {features.map(feature => <div key={feature.name} className="bg-slate-50 p-8 rounded-3xl border border-slate-100 hover:border-blue-200 hover:shadow-md transition-all flex flex-col" data-id="element-5442">
              <div className="h-12 w-12 flex items-center justify-center rounded-xl bg-white border border-slate-200 mb-6 shadow-sm" data-id="element-5443">
                <feature.icon className="h-6 w-6 text-blue-600" data-id="element-5444" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-5445">
                {feature.name}
              </h3>
              <p className="text-slate-500 leading-relaxed flex-1" data-id="element-5446">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}